<template>
  <section class="pin-lei-dong-cha" ref="gongJiYouHua">
    <PageBlock title="供给优化">
      <div class="content">
        <ButtonList :btnList="buttonList" @click="buttonClick"></ButtonList>
        <div class="bar-list">
          <div class="item" v-for="(item, index) in dataList" :key="index">
            <div class="name">{{item.area}}</div>
            <div class="bar" :class="{'index': index % 2}" :style="{width: item.barWidth + 'px'}"></div>
            <div class="num">{{item.quantity}}吨</div>
          </div>
        </div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
import PageBlock from "@/components/page-block.vue";
import ButtonList from "@/components/button-list.vue";
export default {
  name: 'pin-lei-dong-cha',
  components: {
    PageBlock,
    ButtonList
  },
  props: {
    provideOptimizeVoList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    provideOptimizeVoList: {
      handler(val) {
        this.buttonList = val.map(item => {
          this.dateObj[item.category] = item.provideOptimizeList
          return item.category
        })
        if (!this.activeBtn) {
          this.activeBtn = this.buttonList[0]
          setTimeout(() => {
            this.setWidth()
          })
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      buttonList: [],
      dateObj: {},
      activeBtn: '',
      chart: null,
      dataList: [],
      maxWidth: 0
    };
  },
  methods: {
    buttonClick (data) {
      console.log(data, 777777)
      this.activeBtn = data
      let max = this.dateObj[data][0].quantity
      this.dateObj[data].forEach(item => {
        item.barWidth = item.quantity/max*this.maxWidth
      })
      this.dataList = this.dateObj[data]
      console.log(this.dataList, 8888);
    },
    setWidth () {
      console.log(this.activeBtn, this.dateObj[this.activeBtn], 8887777);
      this.maxWidth = this.$refs.gongJiYouHua.clientWidth - 130
      let max = this.dateObj[this.activeBtn][0].quantity
      this.dateObj[this.activeBtn].forEach(item => {
        item.barWidth = item.quantity/max*this.maxWidth
      })
      this.dataList = this.dateObj[this.activeBtn]
    }
  },
};
</script>

<style scoped>
.pin-lei-dong-cha {
  .content{
    .bar-list{
      display: flex;
      flex-direction: column;
      gap: 7px;
      margin-top: 8px;
      .item{
        display: flex;
        font-size: 12px;
        color: #fff;
        .name{
          width: 40px;
        }
        .bar{
          height: 14px;
          overflow: hidden;
          background-color: #51CDD5;
          &.index{
            background-color: #087DCA;
          }
        }
        .num{
          width: 60px;
          padding-left: 6px;
        }
      }
    }
  }
}
</style>
